import React, { useEffect, useState } from "react";
import { FaTimesCircle } from "react-icons/fa";
import PopUp from "../../components/PopUp";
import { InfoBlock, RectBtn } from "../../components/General";
import { useDispatch, useSelector } from "react-redux";
import { selectBuilding, selectDevice, selectRoom, selectUserData } from "../../features/store";
import { updateRoom as updateRoomApi } from "../../apis/Room.Api";
import { updateRoom } from "../../features/slices/roomSlice";
import { useSnackbar } from "notistack";

import { FormControl, MenuItem, Select, TextField } from "@mui/material";

const UpdateConfig = ({ openUpdate, setOpenUpdate, selectedConfig }) => {
    const { enqueueSnackbar } = useSnackbar();
    const userData = useSelector(selectUserData);
    const buildings = useSelector(selectBuilding);
    const rooms = useSelector(selectRoom);
    const devices = useSelector(selectDevice);
    const [newBuilding, setNewBuilding] = useState("");
    const [newFloor, setNewFloor] = useState("");
    const [newRoomName, setNewRoomName] = useState("");
    const [newNano, setNewNano] = useState("");

    const [validateFloor, setValidateFloor] = useState("");
    const [validateName, setValidateName] = useState("");
    const dispatch = useDispatch();
    useEffect(() => {
        if (!selectedConfig.room) return;
        if (!selectedConfig.floor) return;
        setNewFloor(selectedConfig.floor);
        setNewRoomName(selectedConfig.room);
        setNewNano(selectedConfig.nanoId ? selectedConfig.nanoId : "");

        for (let bid in buildings) {
            let building = buildings[bid];
            if (building.buildingName === selectedConfig.building) {
                setNewBuilding(bid);
                break;
            }
        }
    }, [selectedConfig]);

    function validateInput() {
        let valid = true;
        if (newFloor === "") {
            setValidateFloor("Floor cannot be empty");
            valid = false;
        } else {
            setValidateFloor("");
        }
        if (newRoomName === "") {
            setValidateName("Room name cannot be empty");
            valid = false;
        } else {
            for (let rid of Object.keys(rooms)) {
                if (rooms[rid].roomName === newRoomName && rooms[rid].roomName !== selectedConfig.room) {
                    setValidateName("Room name must be unique");
                    valid = false;
                }
            }
        }
        if (valid) {
            setValidateName("");
        }
        return valid;
    }
    async function confirmUpdateConfig() {
        if (!validateInput()) return;

        let r = await updateRoomApi({
            room_id: selectedConfig.id,
            room_name: newRoomName,
            floor: newFloor,
            building_id: buildings[newBuilding].buildingId,
            nano_id: newNano,
        });
        if (r.data.networkError) {
            enqueueSnackbar(r.data.message, { variant: "error" });
            return;
        }

        if (!r.data.indicator) {
            enqueueSnackbar("Failed to edit room. This is possibly due to entering duplicated room name.", {
                variant: "error",
            });
            return;
        }

        dispatch(
            updateRoom({
                roomId: selectedConfig.id,
                roomName: newRoomName,
                floor: newFloor,
                buildingId: buildings[newBuilding].buildingId,
                nanoId: newNano,
            })
        );
        enqueueSnackbar("Room updated.", { variant: "success" });
        setOpenUpdate(false);
    }
    return (
        <PopUp width={70} height={70} switchOn={openUpdate}>
            <div className="pop-up-content-wrapper">
                <div className="pop-up-row">
                    <h4>Edit Config</h4>
                    <FaTimesCircle
                        className="pop-up-close-btn"
                        onClick={() => {
                            setOpenUpdate(false);
                            setNewFloor("");
                            setNewRoomName("");
                            setNewBuilding("");
                            setNewNano("");
                            setValidateName("");
                            setValidateFloor("");
                        }}
                    />
                </div>
                <div className="pop-up-division-line"></div>
                <div className="pop-up-body">
                    <div className="update-content-wrapper">
                        <div className="fields">
                            <InfoBlock title={"Room Name (unique)"}>
                                <TextField
                                    type="text"
                                    placeholder="Room Name"
                                    value={newRoomName}
                                    onChange={(e) => {
                                        setNewRoomName(e.target.value);
                                    }}
                                    inputProps={{ maxLength: 30 }}
                                    error={validateName !== ""}
                                    helperText={validateName}
                                    sx={{ width: 180 }}
                                />
                            </InfoBlock>
                            <InfoBlock title={"Floor"}>
                                <TextField
                                    type="text"
                                    placeholder="Floor"
                                    value={newFloor}
                                    onChange={(e) => {
                                        setNewFloor(e.target.value);
                                    }}
                                    inputProps={{ maxLength: 20 }}
                                    error={validateFloor !== ""}
                                    helperText={validateFloor}
                                    sx={{ width: 180 }}
                                />
                            </InfoBlock>

                            <InfoBlock title={"Building"}>
                                <FormControl sx={{ width: 180 }}>
                                    <Select
                                        id="select-building"
                                        value={newBuilding}
                                        onChange={(e) => {
                                            setNewBuilding(e.target.value);
                                        }}
                                    >
                                        {Object.keys(buildings).map((bid, i) => (
                                            <MenuItem value={bid} key={bid}>
                                                {buildings[bid].buildingName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </InfoBlock>

                            <InfoBlock title={"Nano ID"}>
                                <FormControl sx={{ width: 180 }}>
                                    <Select
                                        id="select-nano"
                                        value={newNano}
                                        onChange={(e) => {
                                            setNewNano(e.target.value);
                                        }}
                                    >
                                        {Object.keys(devices)
                                            .filter((did) => did.toUpperCase().startsWith("N"))
                                            .map((did, i) => (
                                                <MenuItem value={did} key={did}>
                                                    {did}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </InfoBlock>
                        </div>
                        <div>
                            <RectBtn onClick={confirmUpdateConfig}>Confirm</RectBtn>
                        </div>
                    </div>
                </div>
            </div>
        </PopUp>
    );
};

export default UpdateConfig;
